import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';
import { Meta ,Title} from '@angular/platform-browser';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    // Marketing tokens first (so --bronze, --ink, --bg, [data-theme="navy"]
    // overrides resolve), then the shared legal-page skin.
    styleUrls: [
        '../../marketing/marketing-global.scss',
        '../legal-pages.css'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {
  @ViewChild('pricing') pricing;
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal,
    private meta:Meta,
    private title:Title
  ) {
    this.title.setTitle("Privacy Policy | Family Central");
    this.meta.addTag({ name: 'description', content: 'Learn how Family Central protects your data our strict privacy policy.' });
  }

  ngOnInit(): void {
    this.loader.HideLoading();
  }

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  onClose() {
    this.modalService.dismissAll();
  }
}
